'use client'

import { motion, useInView } from 'motion/react'
import React, {useRef, useState} from 'react'
import { useNavigate } from 'react-router-dom';
import earthPic from '@/assets/images/earth.png';
// import leadersPic from '@/assets/images/leaders.png';

import openaiPic from '@/assets/images/mobile-logos/openai.png';
import xaiPic from '@/assets/images/mobile-logos/xai.png';
import neuralinkPic from '@/assets/images/mobile-logos/neuralink.png';
import anthropicPic from '@/assets/images/mobile-logos/anthropic.png';
import spacexPic from '@/assets/images/mobile-logos/spacex.png';
import byteDancePic from '@/assets/images/mobile-logos/byte-dance.png';
import perplexityPic from '@/assets/images/mobile-logos/perplexity.png';
import andurilPic from '@/assets/images/mobile-logos/anduril.png';
import groqPic from '@/assets/images/mobile-logos/groq.png';
import coherePic from '@/assets/images/mobile-logos/cohere.png';
import stripePic from '@/assets/images/mobile-logos/stripe.png';
import figurePic2 from '@/assets/images/mobile-logos/figure.png';

import ipoLinePic from '@/assets/images/ipo-line-mobile.png';
import tableFormatPic from '@/assets/images/table-format.png';
import growthChartPic from '@/assets/images/growth-chart.png';
import handshakePic from '@/assets/images/handshake.png';
import cycleBigPic from "@assets/images/cycle-big.png";
import arrowPic from "@assets/images/arrow.png";
import privateMarketBigPic from "@assets/images/private-market-big.png";
import highQualityBigPic from "@assets/images/high-quality-big.png";
import liquidityBigPic from "@assets/images/liquidity-big.png";
import portalPic from "@assets/images/portal.png";
// import logo1Pic from "@assets/images/logo1.png";
import primary1Pic from "@assets/images/primary1.png";
import primary1HistoryPic from "@assets/images/primary1-history.png";
import figurePic from "@assets/images/figure-ai.png";
import scalePic from "@assets/images/scale-ai.png";
import arrowDownPic from "@assets/images/arrow-down.png";
import arrowUpPic from "@assets/images/arrow-up.png";
import primary2Pic from "@assets/images/primary2.png";
import primary3Pic from "@assets/images/primary3.png";
import superiorNetworkPic from "@assets/images/superior-network.png";
import efficientStructurePic from "@assets/images/efficient-structure.png";
import executionExpertisePic from "@assets/images/execution-expertise.png";
import privateMarketAccessPic from "@assets/images/private-market-access.png";
import leftPic from "@assets/images/left.png";
import rightPic from "@assets/images/right.png";
import headerPic from "@assets/images/header.png";
import logo3Pic from "@assets/images/logo3.png";
import newsBgPic from "@assets/images/news-bg.png";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from 'react-toastify';

type FeatureType = 'cycle' | 'privateMarket' | 'highQuality' | 'liquidity';

export default function InvestmentSolutions() {
  const navigate = useNavigate();

  // const gotoPolarisInvest = ()=>{
  //   window.open('https://invest.polarisagi.com/', '_blank');
  // }

  const startStyle = {opacity: 0}
  const endStyle = {
    opacity: 1,
    ease: 'easeInOut',
  }
  const animationTransition = {
    duration: 2
  }
  const ref1 = useRef(null);
  const isRef1InView = useInView(ref1, {once: true})
  const ref2 = useRef(null);
  const isRef2InView = useInView(ref2, {once: true})
  const ref3 = useRef(null);
  const isRef3InView = useInView(ref3, {once: true})

  const ref4 = useRef(null);
  const isRef4InView = useInView(ref4, {once: true})
  const ref5 = useRef(null);
  const isRef5InView = useInView(ref5, {once: true})
  const ref6 = useRef(null);
  const isRef6InView = useInView(ref6, {once: true})
  const ref7 = useRef(null);
  const isRef7InView = useInView(ref7, {once: true})
  const ref8 = useRef(null);
  const isRef8InView = useInView(ref8, {once: true})
  const ref9 = useRef(null);
  const isRef9InView = useInView(ref9, {once: true})

  const ref10 = useRef(null);
  const isRef10InView = useInView(ref10, {once: true})
  const ref11 = useRef(null);
  const isRef11InView = useInView(ref11, {once: true})

  const [selectedFeature, setSelectedFeature] = useState<FeatureType>('cycle')

  const [isSubscribing, setIsSubscribing] = useState(false);
  const [isBlur, setIsBlur] = React.useState(true);

  const getFeatureIconPic=(featureType: FeatureType)=>{
    switch(featureType){
      case "cycle":
        return cycleBigPic;
      case "privateMarket":
        return privateMarketBigPic;
      case "highQuality":
        return highQualityBigPic;
      case "liquidity":
        return liquidityBigPic;
    }
  }

  const submitForm = ()=>{
    setIsBlur(false)
    const form = document.getElementById('emailForm1') as HTMLFormElement
    if (!form.checkValidity()) {
      form.reportValidity();
      setTimeout(() => {
        setIsBlur(true)
      }, 100)
    } else {
      subscribe()
    }
  }
  const subscribe = async ()=>{
    const emailInput = document.getElementById('emailInput1') as HTMLInputElement;
    const firstNameInput = document.getElementById('firstNameInput1') as HTMLInputElement;
    const lastNameInput = document.getElementById('lastNameInput1') as HTMLInputElement;
    const email = emailInput.value;
    const firstName = firstNameInput.value.trim();
    const lastName = lastNameInput.value.trim();
    setIsSubscribing(true)
    const response = await axios.post(`${import.meta.env.VITE_APP_API_BASE_URL}/polaris-api/subscribe?email=${encodeURIComponent(email)}&firstName=${encodeURIComponent(firstName)}&lastName=${encodeURIComponent(lastName)}`);
    setIsSubscribing(false)

    if (response.data) {
      const { result } = response.data;
      if(result) {
        toast.success('Subscribe successfully.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        emailInput.value=''
        firstNameInput.value=''
        lastNameInput.value=''
      }
    }
  }

  return (
      <div>
        {/* investment区域 */}
        <section id="investment-solutions">
          <section
            className="relative top-0 bg-white overflow-hidden px-6"
            style={{  height: '570px' }}
          >
            {/* 背景图片 - 右侧50%宽度 */}
            <div className="absolute top-0 right-0 w-full h-full z-0" style={{transform: " scale(1) translateX(296px) translateY(-167px) rotateX(180deg) rotate(-56deg)"}}>
              <img
                  src={earthPic}
                  alt="Investment Background"
                  className="object-cover"
              />
              <div className="absolute w-full h-full top-0 left-0  bg-gradient-to-tl from-white/0 to-white/100"></div>
            </div>

            <div className="mx-auto relative z-10">
              <div className="relative w-full" style={{ top: '97px' }}>
                <div className="bg-transparent backdrop-blur-md rounded-2xl"></div>
                <div className="">
                  {/* ASK DAISY 横幅 */}
                  <div className="inline-flex items-center border border-gray-200 rounded-full px-4 py-2 mb-4 hover:border-[#662BFE] transition-all duration-300 ease-in-out cursor-pointer group hover:shadow-[2px_0px_11.300000190734863px_0px_rgba(110,102,225,1.00)]">
                    <Link to="/contact-us" className="text-xs font-medium text-[#6E66E1] transition-colors duration-300 -tracking-wider">Get the Latest News from Polaris</Link>
                    <svg className="w-4 h-4 ml-2 text-gray-500 transform rotate-45 transition-all duration-300 ease-in-out group-hover:text-[#662BFE]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                    </svg>
                  </div>

                  <div className="text-4xl font-medium font-['Figtree'] text-[#121212CC] -tracking-wide mb-[80px] leading-10">
                    Investment<br />Intelligence<br />for a New Era
                  </div>
                  <p className="text-sm font-normal text-[#676767] font-['Figtree'] leading-tight -tracking-wide mb-6 w-full">
                    We believe in transformative growth in the private<br />Polaris. Unlock the potential  of the world's top tech<br />leaders for your portfolio with us.
                  </p>

                  {/* 功能链接 */}
                  <div className="flex flex-col flex-wrap gap-1.5 mb-8 max-w-4xl">
                    <div className="group cursor-pointer relative">
                      <div className="absolute -inset-2 bg-white/90 backdrop-blur-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-out"></div>
                      <Link to="/?section=polaris-20-fund" className="relative inline-flex items-center pl-0 pr-4 scrollable-link">
                        <span className="w-[120px] text-xs font-medium text-[#662BFE] font-['Figtree'] transition-colors duration-300 whitespace-nowrap  bg-gradient-to-r from-[#6E66E1] via-[#5851B3] to-[#3C387BCC] text-transparent bg-clip-text -tracking-wide">POLARIS 20 FUND</span>
                        <svg className="w-[10px] h-[10px] ml-1 text-[#662BFE] transition-all duration-300 ease-out transform group-hover:translate-x-1 inline-block" fill="none" stroke="currentColor"  viewBox="0 0 14 14">
                          <path d="M0.315831 12.8191L11.1434 1.99152L1.86263 1.99152L1.78308 0.745243H13.2736V12.2357L12.0273 12.1562L12.0273 2.8754L1.19971 13.703L0.315831 12.8191Z" strokeWidth="0" fill="url(#paint0_linear_2262_96)"/>
                          <defs>
                            <linearGradient id="paint0_linear_2262_96" x1="1.27043" y1="1.2579" x2="12.7609" y2="12.7484" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#6E66E1"/>
                              <stop offset="0.447115" stopColor="#5851B3"/>
                              <stop offset="1" stopColor="#3C387B" stopOpacity="0.8"/>
                            </linearGradient>
                          </defs>
                        </svg>
                      </Link>
                    </div>
                    <div className="group cursor-pointer relative">
                      <div className="absolute -inset-2 bg-white/90 backdrop-blur-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-out"></div>
                      <Link to="/?section=polaris-co-invest" className="relative inline-flex items-center pl-0 pr-4 scrollable-link">
                        <span className="w-[120px] text-xs font-medium text-[#662BFE] font-['Figtree'] transition-colors duration-300 whitespace-nowrap bg-gradient-to-r from-[#6E66E1] via-[#5851B3] to-[#3C387BCC] text-transparent bg-clip-text -tracking-wide">POLARIS CO-INVEST</span>
                        <svg className="w-[10px] h-[10px] ml-1 text-[#662BFE] transition-all duration-300 ease-out transform group-hover:translate-x-1 inline-block" fill="none" stroke="currentColor"  viewBox="0 0 14 14">
                          <path d="M0.315831 12.8191L11.1434 1.99152L1.86263 1.99152L1.78308 0.745243H13.2736V12.2357L12.0273 12.1562L12.0273 2.8754L1.19971 13.703L0.315831 12.8191Z" strokeWidth="0" fill="url(#paint0_linear_2262_96)"/>
                          <defs>
                            <linearGradient id="paint0_linear_2262_96" x1="1.27043" y1="1.2579" x2="12.7609" y2="12.7484" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#6E66E1"/>
                              <stop offset="0.447115" stopColor="#5851B3"/>
                              <stop offset="1" stopColor="#3C387B" stopOpacity="0.8"/>
                            </linearGradient>
                          </defs>
                        </svg>
                      </Link>
                    </div>
                    <div className="group cursor-pointer relative">
                      <div className="absolute -inset-2 bg-white/90 backdrop-blur-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-out"></div>
                      <Link to="/?section=data-research" className="relative inline-flex items-center pl-0 pr-4 scrollable-link">
                        <span className="w-[120px] text-xs font-medium text-[#662BFE] font-['Figtree'] transition-colors duration-300 whitespace-nowrap bg-gradient-to-r from-[#6E66E1] via-[#5851B3] to-[#3C387BCC] text-transparent bg-clip-text -tracking-wide">DATA & RESEARCH</span>
                        <svg className="w-[10px] h-[10px] ml-1 text-[#662BFE] transition-all duration-300 ease-out transform group-hover:translate-x-1 inline-block" fill="none" stroke="currentColor"  viewBox="0 0 14 14">
                          <path d="M0.315831 12.8191L11.1434 1.99152L1.86263 1.99152L1.78308 0.745243H13.2736V12.2357L12.0273 12.1562L12.0273 2.8754L1.19971 13.703L0.315831 12.8191Z" strokeWidth="0" fill="url(#paint0_linear_2262_96)"/>
                          <defs>
                            <linearGradient id="paint0_linear_2262_96" x1="1.27043" y1="1.2579" x2="12.7609" y2="12.7484" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#6E66E1"/>
                              <stop offset="0.447115" stopColor="#5851B3"/>
                              <stop offset="1" stopColor="#3C387B" stopOpacity="0.8"/>
                            </linearGradient>
                          </defs>
                        </svg>
                      </Link>
                    </div>
                  </div>

                </div>
                {/* 底部位置信息 */}
                <div className="text-xs mt-[30px] text-gray-400">
                  NEW YORK · ZURICH · HONG KONG
                </div>
              </div>
            </div>
          </section>
          {/* 投资组合定位 */}
          <motion.section ref={ref1} initial={startStyle} animate={isRef1InView?endStyle:{}} transition={animationTransition} className="pt-40 pb-[45px] rounded-b-xl relative overflow-hidden">
            {/* 主要水平渐变背景 - 深色饱和的紫色到蓝色到紫色 */}
            <div className="absolute inset-0" style={{
              background:
                  'linear-gradient(180deg, #B2D2EA00 0%, #A5B4EE85 8%, #8B7CF4 38%, #6E66E1 100%)',
            }}></div>
            <div className="px-5 relative z-10">
              <div className="grid grid-cols-1 lg:grid-cols-7 gap-9 items-center">
                {/* 第一个元素占用2列 */}
                <div className="lg:col-span-4">
                  <h2 className="text-4xl font-medium  font-['Figtree'] text-white mb-5 leading-10 -tracking-wider">
                    Position your portfolio<br />
                    alongside top private<br />
                    tech leaders
                  </h2>
                  <p className="text-sm font-normal font-[‘Figtree’] text-white mb-5 leading-tight w-full">
                    Diversify your allocation with systematic strategies, cost-efficient structures, and tailored liquidity.
                  </p>
                  <button onClick={()=>navigate('/contact-us')} className="bg-white text-[#8586FF] px-5 py-2.5 rounded-full text-xs font-medium font-['Figtree'] -tracking-wide transition-all duration-300 ease-in-out flex items-center active:scale-95 group">
                    Get Started
                    <svg className="w-2.5 h-2.5 ml-3 text-[#8586FF] transition-all duration-300 ease-in-out transform group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth="0" viewBox="0 0 14 14">
                      <path d="M0.303136 12.3162L11.1307 1.48859L1.84993 1.48859L1.77038 0.242313H13.2609V11.7328L12.0146 11.6533L12.0146 2.37247L1.18702 13.2L0.303136 12.3162Z" fill="#6E66E1"/>
                    </svg>
                  </button>
                </div>

                {/* 公司 Logo 图片 */}
                {/* grid布局占1列 */}
                <div className="flex justify-end items-end lg:col-span-3">
                  <div className="self-stretch h-64 inline-flex justify-center items-center gap-x-12 gap-y-6 flex-wrap content-center">
                    <div className="w-16 h-5 inline-flex flex-col justify-start items-center gap-12 overflow-hidden">
                      <img alt="OpenAI" className="self-stretch h-5" src={openaiPic} />
                    </div>
                    <div className="w-20 px-4 flex justify-center items-center gap-12 overflow-hidden">
                      <img alt="XAI" className="w-9 h-9" src={xaiPic} />
                    </div>
                    <div className="w-20 h-6 inline-flex flex-col justify-start items-center gap-12 overflow-hidden">
                      <img alt="NEURALINK" className="self-stretch flex-1" src={neuralinkPic} />
                    </div>
                    <div className="w-16 flex justify-start items-center gap-12 overflow-hidden">
                      <img alt="ANTHROPIC" className="flex-1 w-16 h-6" src={anthropicPic} />
                    </div>
                    <div className="w-20 inline-flex flex-col justify-center items-center gap-12 overflow-hidden">
                      <img alt="SpaceX" className="self-stretch h-2.5" src={spacexPic} />
                    </div>
                    <div className="w-20 h-8 inline-flex flex-col justify-start items-center gap-12 overflow-hidden">
                      <img alt="Byte Dance" className="self-stretch h-10" src={byteDancePic} />
                    </div>
                    <div className="w-16 h-6 inline-flex flex-col justify-center items-center gap-12 overflow-hidden">
                      <div className="self-stretch h-4 relative overflow-hidden">
                        <img alt="Perplexity" className="w-16 h-4 left-[1.20px] top-0 absolute" src={perplexityPic} />
                      </div>
                    </div>
                    <div className="w-20 h-6 inline-flex flex-col justify-center items-center gap-12 overflow-hidden">
                      <img alt="ANDURIL" className="self-stretch h-6" src={andurilPic} />
                    </div>
                    <div className="w-20 h-4 px-2.5 inline-flex flex-col justify-start items-center gap-12 overflow-hidden">
                      <img alt="groq" className="w-11 h-4" src={groqPic} />
                    </div>
                    <div className="w-16 h-3 inline-flex flex-col justify-start items-center gap-12 overflow-hidden">
                      <img alt="cohere" className="self-stretch h-3" src={coherePic} />
                    </div>
                    <div className="w-20 h-7 inline-flex flex-col justify-center items-center gap-12 overflow-hidden">
                      <img alt="stripe" className="w-11 h-4" src={stripePic} />
                    </div>
                    <div className="w-20 h-5 inline-flex flex-col justify-start items-center gap-12 overflow-hidden">
                      <img alt="FIGURE" className="w-14 h-4" src={figurePic2} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.section>

          {/* 增长捕捉 */}
          <motion.section ref={ref2} initial={startStyle} animate={isRef2InView?endStyle:{}} transition={animationTransition} className="pt-20 mx-auto overflow-hidden px-5">
            <div className="relative">
              <div className="inset-0 z-10">
                {/* 顶部标题 */}
                <p className="text-[#6E66E1] text-center text-sm font-bold font-['Figtree'] uppercase -tracking-wide mb-5">INVESTMENT STRATEGY</p>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 items-start">
                  {/* 左侧内容 */}
                  <div>
                    <h2 className="text-4xl font-semibold font-['Figtree'] text-[#121212CC] -tracking-wider mb-5 leading-9">
                      Capture growth of the<br />
                      Exceptional before<br />
                      IPO
                    </h2>

                    {/* 三个段落描述 */}
                    <div className="space-y-5 w-full">
                      <p className="text-sm font-normal font-['Figtree'] text-[#676767] leading-tight">
                        We focus on companies that we expect to be the leaders, enablers, and beneficiaries of disruptive innovation. Polaris' strategies aim to deliver a low-friction, systemic and data-driven approach for investors to capture values from the next wave of blue-chap tech companies.
                      </p>
                      <p className="text-sm font-normal font-['Figtree'] text-[#676767] leading-tight">
                        Value creation has shifted to private Polaris, where top pre-IPO tech leaders drive strong returns and diversified growth.
                      </p>
                      <p className="text-sm font-normal font-['Figtree'] text-[#676767] lleading-tight">
                        As companies stay private longer, they raise capital to fuel growth. This shift has deepened secondary Polaris liquidity, creating new access points for investors and liquidity options for existing shareholders.
                      </p>
                    </div>
                  </div>

                  {/* 右侧统计框 */}
                  <div className="space-y-4 flex flex-col items-center">
                    {/* 第一行：两个统计框 */}
                    <div className="grid grid-cols-1 gap-4">
                      <div className="w-full h-[120px] grid grid-cols-2 gap-6 items-center bg-white border border-[#6E66E1] rounded-lg p-4">
                        <div className="text-5xl font-semibold font-['Figtree'] text-purple-600 mb-2 text-center" style={{
                          background: 'linear-gradient(180deg, #6E66E1 0%, #B9A5EF 100%)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          backgroundClip: 'text',
                          color: 'transparent'
                        }}>$162B</div>
                        <div className="text-sm font-normal font-['Figtree'] text-[#424242] leading-tight -tracking-wide">
                          Of The Top 20 Unicorns Exited Via IPO Or M&A In The Last 10 Years.
                        </div>
                      </div>
                      <div className="w-full h-[120px] grid grid-cols-2 gap-6 items-center bg-white border border-[#6E66E1] rounded-lg p-4">
                        <div className="text-5xl font-semibold font-['Figtree'] text-purple-600 mb-2 text-center" style={{
                          background: 'linear-gradient(180deg, #6E66E1 0%, #B9A5EF 100%)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          backgroundClip: 'text',
                          color: 'transparent'
                        }}>294%</div>
                        <div className="text-sm font-normal font-['Figtree'] text-[#424242] leading-tight -tracking-wide">
                          Top 20 Unicorn Outperformance Vs. Public Equities Over The Past Decade.
                        </div>
                      </div>
                    </div>

                    {/* 第二行：一个宽统计框 */}
                    <div className="flex justify-end">
                      <div className="w-full h-[120px] grid grid-cols-2 gap-6 items-center bg-white border border-[#6E66E1] rounded-lg p-4">
                        <div className="text-5xl font-semibold font-['Figtree'] text-purple-600 mb-2 text-center" style={{
                          background: 'linear-gradient(180deg, #6E66E1 0%, #B9A5EF 100%)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          backgroundClip: 'text',
                          color: 'transparent'
                        }}>69%</div>
                        <div className="text-sm font-normal font-['Figtree'] text-[#424242] leading-tight -tracking-wide">
                          In Secondary Polaris Activity, Making The Largest Unicorns More Liquid.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="relative mt-5">
                <img
                  src={ipoLinePic}
                  alt="IPO Growth Line Chart Background"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="relative mt-5">
                <div className="justify-start text-stone-500/90 text-[8px] font-normal font-['Figtree'] leading-[8px]">Top line: Morningstar PitchBook® Unicorn Select 20 Index**</div>
                <div className="justify-start text-stone-500/90 text-[8px] font-normal font-['Figtree'] leading-[8px] mt-[5px]">Bottom line: Public Equities*</div>
                <div className="self-stretch justify-start text-zinc-500 text-[8px] font-normal font-['Figtree'] leading-[8px] mt-3">Please note that the information provided above is for illustrative purposes only and should not be construed as financial advice. Past performance is not indicative of future results, and historical data should not be relied upon as a guarantee of future performance. Furthermore, please be aware that the information presented is not intended to be represent any specific product or investment, and is not intended to be treated as such. Please consult with a licensed financial advisor before making any investment decisions.</div>
              </div>
            </div>
          </motion.section>

          {/* 投资解决方案 */}
          <motion.section ref={ref3} initial={startStyle} animate={isRef3InView?endStyle:{}} transition={animationTransition} className="py-20 bg-white px-6">
            <div className="mx-auto">
              {/* 顶部标题 */}
              <div className="text-center mb-5">
                <p className="text-[#6E66E1] text-sm font-bold font-['Figtree'] uppercase -tracking-wide mb-2">OUR SOLUTIONS</p>
                <h2 className="text-4xl font-semibold font-['Figtree'] text-[#121212CC] -tracking-wider mb-5 leading-none">
                  With Polaris<br />Investment Solutions
                </h2>
                <p className="text-sm font-normal font-['Figtree'] text-[#676767] max-w-3xl mx-auto leading-tight">
                  At any stage of your private Polaris allocation, Polaris is the right fit.
                </p>
              </div>

              {/* 三列卡片 */}
              <div className="grid grid-cols-1 gap-8">
                {/* 卡片1 */}
                <div id="polaris-20-fund" className="rounded-[12px] border border-[#A78BFA]/60 p-8 flex flex-col hover:border-[#6E66E1] hover:shadow-lg transition-all duration-300 ease-in-out hover:scale-105 cursor-pointer">
                  <div className="w-full h-55 rounded-md mb-[35px] flex items-center justify-center">
                    <img src={tableFormatPic} alt="Polaris 20 Fund" className="max-h-full object-contain" />
                  </div>
                  <h3 className="text-2xl font-semibold text-[#676767] font-['Figtree'] mb-5 -tracking-wide">Polaris 20 Fund</h3>
                  <p className="text-sm font-normal font-['Figtree'] text-[#676767] leading-tight -tracking-wide">
                    Invest in a passive, systematic portfolio of the Top 20 global private tech companies with low-friction, semi-liquid, open-ended access.
                  </p>
                  <div className="mt-auto pt-[25px]">
                    <Link to={`/contact-us`} className="text-[#6E66E1] text-sm font-bold font-['Figtree'] inline-flex items-center group hover:text-[#8586FF] transition-all duration-300 ease-in-out hover:scale-105">
                      Contact Us <svg className="w-[10px] h-[10px] ml-2 text-[#6E66E1] transform transition-all duration-300 ease-in-out group-hover:text-[#8586FF] group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth="0" viewBox="0 0 14 14">
                      <path d="M0.303136 12.3162L11.1307 1.48859L1.84993 1.48859L1.77038 0.242313H13.2609V11.7328L12.0146 11.6533L12.0146 2.37247L1.18702 13.2L0.303136 12.3162Z" fill="#6E66E1"/>
                    </svg>
                    </Link>
                  </div>
                </div>

                {/* 卡片2 */}
                <div id="polaris-co-invest" className="rounded-[12px] border border-[#A78BFA]/60 p-8 flex flex-col hover:border-[#6E66E1] hover:shadow-lg transition-all duration-300 ease-in-out hover:scale-105 cursor-pointer">
                  <div className="w-full h-55 rounded-md mb-[35px] flex items-center justify-center">
                    <img src={handshakePic} alt="Co‑Invest" className="max-h-full object-contain" />
                  </div>
                  <h3 className="text-2xl font-semibold text-[#676767] font-['Figtree'] mb-5 -tracking-wide">Co‑Invest</h3>
                  <p className="text-sm font-normal font-['Figtree'] text-[#676767] leading-tight -tracking-wide">
                    Access tailored co‑investment opportunities to double down on single companies for fund investors.
                  </p>
                  <div className="mt-auto pt-[25px]">
                    <Link to={`/contact-us`} className="text-[#6E66E1] text-sm font-bold font-['Figtree'] inline-flex items-center group hover:text-[#8586FF] transition-all duration-300 ease-in-out hover:scale-105">
                      Contact Us <svg className="w-[10px] h-[10px] ml-2 text-[#6E66E1] transform transition-all duration-300 ease-in-out group-hover:text-[#8586FF] group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth="0" viewBox="0 0 14 14">
                      <path d="M0.303136 12.3162L11.1307 1.48859L1.84993 1.48859L1.77038 0.242313H13.2609V11.7328L12.0146 11.6533L12.0146 2.37247L1.18702 13.2L0.303136 12.3162Z" fill="#6E66E1"/>
                    </svg>
                    </Link>
                  </div>
                </div>

                {/* 卡片3 */}
                <div id="data-research" className="rounded-[12px] border border-[#A78BFA]/60 p-8 flex flex-col hover:border-[#6E66E1] hover:shadow-lg transition-all duration-300 ease-in-out hover:scale-105 cursor-pointer">
                  <div className="w-full h-55 rounded-md mb-[35px] flex items-center justify-center">
                    <img src={growthChartPic} alt="Data & Research" className="max-h-full object-contain" />
                  </div>
                  <h3 className="text-2xl font-semibold text-[#676767] font-['Figtree'] mb-5 -tracking-wide">Data & Research</h3>
                  <p className="text-sm font-normal font-['Figtree'] text-[#676767] leading-tight -tracking-wide">
                    Invest in an actively managed strategy that seeks long‑term growth of capital.
                  </p>
                  <div className="mt-auto pt-[25px]">
                    <Link to={`/contact-us`} className="text-[#6E66E1] text-sm font-bold font-['Figtree'] inline-flex items-center group hover:text-[#8586FF] transition-all duration-300 ease-in-out hover:scale-105">
                      Contact Us <svg className="w-[10px] h-[10px] ml-2 text-[#6E66E1] transform transition-all duration-300 ease-in-out group-hover:text-[#8586FF] group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth="0" viewBox="0 0 14 14">
                      <path d="M0.303136 12.3162L11.1307 1.48859L1.84993 1.48859L1.77038 0.242313H13.2609V11.7328L12.0146 11.6533L12.0146 2.37247L1.18702 13.2L0.303136 12.3162Z" fill="#6E66E1"/>
                    </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </motion.section>
        </section>

        {/* ------------------- */}

        <section id="why-private-tech">
          {/* 私有科技价值-新 */}
          <motion.section ref={ref4} initial={startStyle} animate={isRef4InView?endStyle:{}} transition={animationTransition} className="relative pb-16 bg-white">
            <div className="mx-auto text-center flex flex-col item-center">
              <div className="self-stretch py-14 px-5 origin-top-left bg-gradient-to-t from-violet-400 to-indigo-500 rounded-xl outline outline-1 outline-offset-[-1px] inline-flex flex-col justify-center items-center gap-10 overflow-hidden">
                <div className="w-full origin-top-left flex justify-start text-left text-white text-4xl font-medium font-['Figtree'] leading-9">Why Private Tech ─<br/>Innovation meets value creation</div>

                <div className="w-full h-80 px-2.5 py-5 origin-top-left bg-white/10 rounded-xl shadow-[0px_0px_0px_1px_rgba(255,255,255,0.10)] shadow-[0px_2px_3.4000000953674316px_0px_rgba(102,43,254,0.02)] inline-flex justify-center items-center gap-24">
                  <div className="flex-1 inline-flex flex-col justify-center items-start gap-2.5">
                    <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
                      <div className="self-stretch border-b border-white inline-flex justify-between items-center cursor-pointer" onClick={()=>setSelectedFeature('cycle')}>
                        <div className="justify-center text-white text-base font-bold font-['Figtree'] leading-9 hover:text-[#FFFFFFCC]">Early in Growth Cycle</div>
                        <div className={`w-4 h-4 origin-center transition-all duration-300 ${selectedFeature==='cycle'?'-rotate-90':''}`}>
                          <img
                            src={arrowPic}
                            alt=""
                            className="w-4 h-4"
                          />
                        </div>
                      </div>
                      {selectedFeature=='cycle'&&(
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: 'auto', opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.5, ease: "easeInOut" }}
                          className="self-stretch justify-center text-left text-white text-sm font-normal font-['Figtree'] leading-tight overflow-hidden -tracking-wide"
                        >With over 1,565 unicorns valued at $5.2 trillion—and growing—private blue-chip tech companies offer unparalleled growth potential. </motion.div>
                      )}
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
                      <div className="self-stretch border-b border-white inline-flex justify-between items-center cursor-pointer" onClick={()=>setSelectedFeature('highQuality')}>
                        <div className="justify-center text-white text-base font-bold font-['Figtree'] leading-9 hover:text-[#FFFFFFCC]">Today’s Leaders are High-quality</div>
                        <div className={`w-4 h-4 origin-center transition-all duration-300 ${selectedFeature==='highQuality'?'-rotate-90':''}`}>
                          <img
                            src={arrowPic}
                            alt=""
                            className="w-4 h-4"
                          />
                        </div>
                      </div>
                      {selectedFeature=='highQuality'&&(
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: 'auto', opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.5, ease: "easeInOut" }}
                          className="self-stretch justify-center text-left text-white text-sm font-normal font-['Figtree'] leading-tight overflow-hidden -tracking-wide"
                        >AI, fintech, space-tech, and other disruptive sectors are driving innovation and are accessible only in private Polaris. </motion.div>
                      )}
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
                      <div className="self-stretch border-b border-white inline-flex justify-between items-center cursor-pointer" onClick={()=>setSelectedFeature('liquidity')}>
                        <div className="justify-center text-white text-base font-bold font-['Figtree'] leading-9 hover:text-[#FFFFFFCC]">Greater Polaris Liquidity</div>
                        <div className={`w-4 h-4 origin-center transition-all duration-300 ${selectedFeature==='liquidity'?'-rotate-90':''}`}>
                          <img
                            src={arrowPic}
                            alt=""
                            className="w-4 h-4"
                          />
                        </div>
                      </div>
                      {selectedFeature=='liquidity'&&(
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: 'auto', opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.5, ease: "easeInOut" }}
                          className="self-stretch justify-center text-left text-white text-sm font-normal font-['Figtree'] leading-tight overflow-hidden -tracking-wide"
                        >Secondary Polaris are expanding, providing greater liquidity and real-time, transparent pricing.</motion.div>
                      )}
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
                      <div className="self-stretch border-b border-white inline-flex justify-between items-center cursor-pointer" onClick={()=>setSelectedFeature('privateMarket')}>
                        <div className="justify-center text-white text-left text-base font-bold font-['Figtree'] leading-tight hover:text-[#FFFFFFCC]">Shifting Value Creation Towards Private Polaris</div>
                        <div className={`w-4 h-4 origin-center transition-all duration-300 ${selectedFeature==='privateMarket'?'-rotate-90':''}`}>
                          <img
                            src={arrowPic}
                            alt=""
                            className="w-4 h-4"
                          />
                        </div>
                      </div>
                      {selectedFeature=='privateMarket'&&(
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: 'auto', opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.5, ease: "easeInOut" }}
                          className="self-stretch justify-center text-left text-white text-sm font-normal font-['Figtree'] leading-tight overflow-hidden -tracking-wide"
                        >Companies are staying private longer, capturing more value before IPOs and shifting growth from public to private Polaris.</motion.div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.section>
        </section>
        <section id="data-research-portal">
          {/* AI 门户数据 */}
          <motion.section ref={ref5} initial={startStyle} animate={isRef5InView?endStyle:{}} transition={animationTransition} className="bg-white">
            <div className="mx-auto px-6 sm:px-8 lg:px-10 text-center flex flex-col item-center">
              <p className="text-[#6E66E1] text-sm font-bold font-['Figtree'] uppercase -tracking-wide mb-2">intelligent insight tools</p>
              <h2 className="text-4xl font-semibold text-[#414141] font-['Figtree'] mb-6 leading-9 -tracking-wider">
                Real-time private
                <br className="block" />
                company data &
                <br className="block" />
                research with Polaris
                <br className="block" />
                AI Portal™
              </h2>
              <p className="w-full mx-auto text-center text-sm font-normal font-['Figtree'] text-[#676767] leading-tight">
                Polaris Polaris‑data provides best‑in‑class price estimates and research for actively traded pre‑IPO companies
              </p>
              <div className="max-w-5xl mx-auto">
                <div className="max-w-5xl mx-auto flex items-end justify-center gap-6">
                  <img src={portalPic} alt="Portal Preview" className="object-cover" />
                </div>
              </div>
            </div>
          </motion.section>

          {/* 数据聚合 */}
          <motion.section ref={ref6} initial={startStyle} animate={isRef6InView?endStyle:{}} transition={animationTransition} className="pt-20 bg-white px-6">
            <div className="mx-auto">
              {/* 顶部合成图 */}
              <div className="rounded-2xl bg-[#0000000A] px-3 py-5 mb-5">
                <div className="flex items-start justify-between mb-[20px]">
                  <div>
                    <h3 className="font-['Figtree'] font-medium text-lg leading-tight -tracking-wide" style={{
                      background: 'linear-gradient(180deg, #B6B1FA 0%, #6E66E1 21.15%, #3C387B 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text',
                      color: 'transparent'
                    }}>Primary round details and secondary<br /> Polaris data, all in one place</h3>
                    <p className="text-[#676767] text-sm font-normal font-['Figtree'] leading-tight mt-[10px] max-w-2xl -tracking-wide">Achieve your financial dreams with our comprehensive financial planning <br/> services, guiding you toward a secure future.</p>
                  </div>
                </div>
                {/* captions under three preview cards */}
                <div className="grid grid-cols-1 gap-10">
                  <div className="">
                    <div className="relative">
                      <img src={primary1Pic} alt="Portal Preview" className="rounded-xl" />
                    </div>
                    <div className="text-lg font-medium font-['Figtree'] text-[#000000] leading-tight mt-5">Funding Rounds</div>
                    <div className="text-sm font-normal font-['Figtree'] text-[#424242] leading-tight break-words -tracking-wide">Primary round investment history and filings</div>
                  </div>
                  <div className="">
                    <div className="relative">
                      <div className="relative">
                        <img src={primary1Pic} alt="Portal Preview" className="rounded-xl" />
                      </div>
                    </div>
                    <div className="text-lg font-medium font-['Figtree'] text-[#000000] leading-7 mt-5">Investors</div>
                    <div className="w-[80%] text-base font-normal font-['Figtree'] text-[#424242] leading-tight break-words">Explore private company investors, including their investment prices & dates</div>
                  </div>
                  <div className="">
                    <div className="relative">
                      <img src={primary1HistoryPic} alt="Portal Preview" className="rounded-xl" />
                    </div>
                    <div className="text-lg font-medium font-['Figtree'] text-[#000000] leading-7 mt-5">Transaction History</div>
                    <div className="w-[80%] text-base font-normal font-['Figtree'] text-[#424242] leading-tight break-words">Over 3 years of secondary closed transaction data</div>
                  </div>
                </div>
              </div>

              {/* 下方分解图布局 */}
              <div className="grid grid-cols-1 gap-6">
                <div className="">
                  <div className="rounded-2xl bg-[#0000000A] px-3 py-5 mb-7">
                    <div className="flex items-start justify-between mb-[10px]">
                      <h4 className="leading-tight font-medium font-['Figtree'] text-lg -tracking-wide" style={{
                        background: 'linear-gradient(180deg, #B6B1FA 0%, #6E66E1 21.15%, #3C387B 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        color: 'transparent'
                      }}>Institutional Investors</h4>
                    </div>
                    <p className="text-[#676767] text-sm font-normal font-['Figtree'] max-w-2xl w-full leading-tight -tracking-wide">Monitor a range of private Polaris investments with our platform and comprehensive data reporting.</p>
                    <div className="rounded-xl overflow-hidden mt-[22px]">
                      <div className="relative">
                        <img src={primary2Pic} alt="Portal Preview" className="" />
                      </div>

                    </div>
                  </div>
                  <div className="rounded-2xl bg-[#0000000A] px-3 py-5 mb-[10px]">
                    <div className="flex items-start justify-between mb-4">
                      <h4 className="leading-tight font-medium text-lg font-['Figtree'] -tracking-wide" style={{
                        background: 'linear-gradient(180deg, #B6B1FA 0%, #6E66E1 21.15%, #3C387B 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        color: 'transparent'
                      }}>Sector and Polaris Insights for<br/> sophisticated investors</h4>
                    </div>
                    <p className="text-[#676767] text-sm font-normal font-['Figtree'] leading-tight max-w-2xl w-full -tracking-wide">Achieve your financial dreams with our comprehensive financial planning services, guiding you toward a secure future.</p>
                    <div className="rounded-xl overflow-hidden mt-[22px]">
                      <div className="relative">
                        <img src={primary3Pic} alt="Portal Preview" className="" />
                      </div>

                    </div>
                  </div>
                </div>

                {/* 左侧 Top Movers 列表 */}
                <div className="relative rounded-2xl max-h-[968px] bg-[#0000000A] p-5">
                  <div className="flex items-start justify-between mb-2">
                    <h4 className="leading-7 font-medium font-['Figtree'] text-lg -tracking-wide" style={{
                      background: 'linear-gradient(180deg, #B6B1FA 0%, #6E66E1 21.15%, #3C387B 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text',
                      color: 'transparent'
                    }}>Top Movers</h4>
                  </div>
                  <p className="text-[#676767] text-sm font-normal font-['Figtree'] max-w-2xl leading-[1.15] -tracking-wide">Top gainers and losers across late-stage private companies</p>
                  <div className="space-y-4 mt-4 overflow-y-auto " style={{ height: 'calc(100% - 115px)',
                    // 隐藏滚动条但仍保持滚动功能
                    msOverflowStyle: 'none',  /* IE and Edge */
                    scrollbarWidth: 'none'   /* Firefox */
                  }}>
                    <div style={{
                      /* 隐藏webkit浏览器滚动条 */
                      WebkitOverflowScrolling: 'touch'
                    } as React.CSSProperties}>
                      {/* Item 1 */}
                      <div className="rounded-xl bg-white px-4 py-7 mb-3">
                        <div className="flex items-center mb-3">
                          <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center mr-4 overflow-hidden">
                            <img src={figurePic} alt="Figure AI" className="w-10 h-10 object-contain" />
                          </div>
                          <div className="text-xl font-medium font-['Figtree'] leading-normal text-[#121212]">Figure AI</div>
                        </div>
                        <div className="grid grid-cols-2 gap-4 text-sm">
                          <div>
                            <div className="text-sm font-medium font-['Figtree'] leading-normal text-[#121212] mb-1">$ Change</div>
                            <div className="text-[#FF3333] text-lg font-normal font-['Figtree'] leading-normal">$280.4 <img alt="" src={arrowDownPic} className="w-2 h-4 inline-block relative -top-0.5 left-0.5" style={{ objectFit: 'contain' }} /></div>
                          </div>
                          <div>
                            <div className="text-sm font-medium font-['Figtree'] leading-normal text-[#121212] mb-1">% Change</div>
                            <div className="text-[#FF3333] text-lg font-normal font-['Figtree'] leading-normal">66% <img alt="" src={arrowDownPic} className="w-2 h-4 inline-block relative -top-0.5 left-0.5" style={{ objectFit: 'contain' }} /></div>
                          </div>
                          <div>
                            <div className="text-sm font-medium font-['Figtree'] leading-normal text-[#121212] mb-1">Price Per Share</div>
                            <div className="text-[#414141] text-lg font-normal font-['Figtree'] leading-normal">$18.40</div>
                          </div>
                          <div>
                            <div className="text-sm font-medium font-['Figtree'] leading-normal text-[#121212] mb-1">Valuation</div>
                            <div className="text-[#414141] text-lg font-normal font-['Figtree'] leading-normal">$14.46B</div>
                          </div>
                        </div>
                      </div>
                      {
                        [1,2,3].map((item) => (
                          <div key={item} className="rounded-xl bg-white px-4 py-7 mb-3">
                            <div className="flex items-center mb-3">
                              <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center mr-4 overflow-hidden">
                                <img src={scalePic} alt="Scale AI" className="w-10 h-10 object-contain" />
                              </div>
                              <div className="text-xl font-medium font-['Figtree'] leading-normal text-[#121212]">Scale AI</div>
                            </div>
                            <div key={ item } className="grid grid-cols-2 gap-4 text-sm">
                              <div>
                                <div className="text-sm font-medium font-['Figtree'] leading-normal text-[#121212]">$ Change</div>
                                <div className="text-[#72EC72] text-lg font-normal font-['Figtree'] leading-norma">$280.4 <img alt="" src={arrowUpPic} className="w-2 h-4 inline-block relative -top-0.5 left-0.5" style={{ objectFit: 'contain' }} /></div>
                              </div>
                              <div>
                                <div className="text-sm font-medium font-['Figtree'] leading-normal text-[#121212]">% Change</div>
                                <div className="text-[#72EC72] text-lg font-normal font-['Figtree'] leading-norma">66% <img alt="" src={arrowUpPic} className="w-2 h-4 inline-block relative -top-0.5 left-0.5" style={{ objectFit: 'contain' }} /></div>
                              </div>
                              <div>
                                <div className="text-sm font-medium font-['Figtree'] leading-normal text-[#121212]">Price Per Share</div>
                                <div className="text-[#414141] text-lg font-normal font-['Figtree'] leading-normal">$18.40</div>
                              </div>
                              <div>
                                <div className="text-sm font-medium font-['Figtree'] leading-normal text-[#121212]">Valuation</div>
                                <div className="text-[#414141] text-lg font-normal font-['Figtree'] leading-normal">$14.46B</div>
                              </div>
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.section>

          {/* 信任原因 */}
          <motion.section ref={ref7} initial={startStyle} animate={isRef7InView?endStyle:{}} transition={animationTransition} className="pt-10 bg-white relative px-6">
            <div className="mx-auto">
              <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12">
                {/* 左侧文案 */}
                <div className="my-auto">
                  <p className="text-[#6E66E1] text-sm font-bold font-['Figtree'] -tracking-wide uppercase mb-2 text-center">BACKED BY EXPERIENCE</p>
                  <h2 className="font-semibold text-4xl font-['Figtree'] text-[#121212CC] -tracking-wider leading-9 text-center">
                    Why leading firms
                    <br className="block" />
                    trust us for private
                    <br className="block" />
                    Polaris access
                  </h2>
                  <p className="text-sm font-normal font-['Figtre'] text-[#676767] mt-5 mb-8 leading-tight -tracking-wide w-full">
                    Navigating private Polaris is complex. We make it simple, scalable, and systematic. Invest with Polaris trusted by 100+ financial firms, with a proven track record of 130+ successful transactions.
                  </p>
                </div>
                <div className="my-auto">
                  {/* 定位到右下角的卡片 */}
                  <div className="mb-[100px]">
                    {/* 卡片 1 */}
                    <div className="bg-white p-5 backdrop-blur border border-gray-200 rounded-xl shadow-[0_8px_24px_rgba(0,0,0,0.08)] mb-4">
                      <div>
                        <div className="flex items-center justify-start">
                          <img
                            src={superiorNetworkPic}
                            alt=""
                            className="mr-5"
                          />
                          <div className="text-lg font-semibold font-['Figtree'] -tracking-wide text-[#121212CC]">Superior Network</div>
                        </div>
                        <div className="text-sm font-normal font-['Figtree'] text-[#12121280] mt-2 leading-tight -tracking-wide">Proprietary deal flow across a fragmented, in‑transparent & inefficient secondary Polaris</div>
                      </div>
                    </div>

                    {/* 卡片 2 */}
                    <div className="bg-white p-5 backdrop-blur border border-gray-200 rounded-xl shadow-[0_8px_24px_rgba(0,0,0,0.08)] mb-4">
                      <div>
                        <div className="flex items-center justify-start">
                          <img
                            src={efficientStructurePic}
                            alt=""
                            className="mr-5"
                          />
                          <div className="text-lg font-semibold font-['Figtree'] -tracking-wide text-[#121212CC]">Efficient Structure</div>
                        </div>
                        <div className="text-sm text-[#12121280] mt-2 leading-snug">Capability to aggregate investor demand across structures, co‑investments, and client types</div>
                      </div>
                    </div>

                    {/* 卡片 3 */}
                    <div className="bg-white p-5 backdrop-blur border border-gray-200 rounded-xl shadow-[0_8px_24px_rgba(0,0,0,0.08)]">
                      <div>
                        <div className="flex items-center justify-start">
                          <img
                            src={executionExpertisePic}
                            alt=""
                            className="mr-5"
                          />
                          <div className="text-lg font-semibold font-['Figtree'] -tracking-wide text-[#121212CC]">Execution Expertise</div>
                        </div>
                        <div className="text-sm text-[#12121280] mt-2 leading-snug">Investment committee with 15+ years experience and 100+ investment conducted</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 定位到整个信任原因部分右下角的图片 */}
            <div className="absolute bottom-10 right-0">
              <img
                src={privateMarketAccessPic}
                alt=""
                className="object-cover rounded-[10px]"
              />
            </div>
          </motion.section>

          {/* 客户评价 */}
          <motion.section ref={ref8} initial={startStyle} animate={isRef8InView?endStyle:{}} transition={animationTransition} className="py-20 bg-white overflow-hidden display-none">
            <div className="mx-auto">
              <h2 className="leading-tight font-medium text-6xl text-[#121212]">
                What our investors
                <br className="hidden sm:block" />
                say about us
              </h2>

              {/* Slider-like row */}
              <div className="mt-10 relative flex items-start space-x-3">
                {/* Arrows */}
                <div className="flex items-center space-x-3 z-10">
                  <button className="w-10 h-10 rounded-full bg-[#F6F6F9] text-gray-600 hover:bg-[#6E66E1] hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center hover:scale-110 hover:shadow-lg group">
                    <span className="sr-only">Previous</span>
                    <img
                      src={leftPic}
                      alt=""
                      className="transition-all duration-300 ease-in-out group-hover:brightness-0 group-hover:invert"
                    />
                  </button>
                  <button className="w-10 h-10 rounded-full bg-[#F6F6F9] text-gray-600 hover:bg-[#6E66E1] hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center hover:scale-110 hover:shadow-lg group">
                    <span className="sr-only">Next</span>
                    <img
                      src={rightPic}
                      alt=""
                      className="transition-all duration-300 ease-in-out group-hover:brightness-0 group-hover:invert"
                    />
                  </button>
                </div>

                {/* Cards row */}
                <div className="flex gap-6">
                  {/* Active card */}
                  {[1,2,3].map((item) => (
                    <div key={item} className="w-[586px] bg-white border border-gray-200 rounded-2xl p-12 shadow-sm" style={{opacity: 1/item}}>
                      <blockquote className="text-[#676767] text-xl leading-7 mb-8">
                        “Lorem ipsum dolor sit amet, consectetur adipiscing elit. In commodo dolor fermentum dignissim et pellentesque egestas mauris, faucibus. Tellus nisi amet non at phasellus faucibus senectus in”
                      </blockquote>
                      <div className="flex items-center">
                        <img src={headerPic} alt="avatar" className="w-11 h-11 rounded-full object-cover mr-3" />
                        <div>
                          <div className="text-[#676767] font-semibold text-sm">JOHN CARTER</div>
                          <div className="text-[#676767] text-xs tracking-wide">ROLE, COMPANY</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </motion.section>

          {/* 增长潜力行动号召 */}
          <motion.section ref={ref9} initial={startStyle} animate={isRef9InView?endStyle:{}} transition={animationTransition} className="py-20 bg-white px-6">
            <div className="mx-auto">
              <div className="grid grid-cols-1 gap-2 items-center ">
                {/* 左侧说明 */}
                <div className="col-span-1">
                  <p className="text-[#6E66E1] text-sm font-bold font-['Figtree'] uppercase mb-2">EXCLUSIVE REPORTS</p>
                  <h2 className="text-4xl font-semibold font-['Figtree'] text-[#121212CC] mb-4 -tracking-wider leading-none">
                    Unlock growth
                    <br className="block" />
                    potential
                    <br className="block" />
                    in Private Markets
                  </h2>
                  <p className="text-sm font-normal text-[#676767] font-['Figtree'] mb-8 leading-tight w-full -tracking-wide">
                    Learn how investing in unicorns can provide liquidity, portfolio flexibility, and access to the Top 20 most valuable companies before their IPO. Sign up to receive an exclusive white paper on the VC and pre‑IPO secondaries Polaris.
                  </p>
                </div>

                {/* 右侧订阅卡片 */}
                <div className="col-span-1 w-full flex justify-center">
                  <div className="w-full max-w-md bg-[#F8F8F8] rounded-2xl px-5 py-9 shadow-sm">
                    {/* 顶部小星星 */}
                    <div className="w-8 h-8 mx-auto mb-6 text-[#6E66E1] flex items-center justify-center">
                      <img src={logo3Pic} alt="" />
                    </div>

                    <form id="emailForm1" onSubmit={(e)=>{e.preventDefault();}} className="space-y-4">
                      <input id="firstNameInput1" type="text" required placeholder="First Name" className="w-full px-4 h-10 rounded-full border border-[#D8D8D8] bg-white text-[#636262] text-xs font-normal font-['Figtree'] focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none" />
                      <input id="lastNameInput1" type="text" required placeholder="Last Name" className="w-full px-4 h-10 rounded-full border border-[#D8D8D8] bg-white text-[#636262] text-xs font-normal font-['Figtree'] focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none" />
                      <input
                        id="emailInput1"
                        type="email"
                        placeholder="Email"
                        className="w-full px-4 h-10 rounded-full border border-[#D8D8D8] bg-white text-[#636262] text-xs font-normal font-['Figtree'] focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none"
                        required
                        disabled={isSubscribing}
                        onKeyDown={(e) => {
                          setIsBlur(false);
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            const input = e.target as HTMLInputElement;
                            input.setCustomValidity('');
                            if (!input.checkValidity()) {
                              input.setCustomValidity('');
                            }
                            input.reportValidity();
                          } else {
                            const input = e.target as HTMLInputElement;
                            // 将验证信息设置为多个空格，可让验证信息不显示
                            input.setCustomValidity('  ');
                          }
                        }}
                        onBlur={(e)=>{
                          const input = e.target as HTMLInputElement;
                          if(!isBlur){
                            setIsBlur(true);
                            if (!input.checkValidity()) {
                              input.setCustomValidity('');
                            }
                          }
                        }}
                      />

                      <div className="flex items-start space-x-4">
                        <input required id="consent" type="radio" className="h-4 w-4 text-[#F8F8F8] border-gray-300 bg-white rounded cursor-pointer" style={{
                          accentColor: '#6B5AE6',
                          '--tw-ring-color': '#6B5AE6',
                          // 强制使用浅色主题，不受系统dark mode影响
                          'colorScheme': 'light',
                          // 确保未选中时背景和中心为白色
                          backgroundColor: 'white',
                          // 确保边框颜色
                          borderColor: '#d1d5db',
                          // 确保在dark mode下文字颜色不会变暗
                          color: '#000000'
                        } as React.CSSProperties} />
                        <label htmlFor="consent" className="text-[12px] font-['Figtree'] text-[#676767] leading-3">
                          I accept Polaris' <Link to={`/privacy-policy`} target={`_blank`} className={`underline underline-offset-2`}>Privacy Policy</Link> to receive the guide and Polarising info on growth equity and pre‑IPO investments. I consent to Personal Data processing for relevant updates. I confirm I've read and accept the <Link to={`/disclaimer`} target={`_blank`} className={`underline underline-offset-2`}>Disclaimer</Link>. I can opt out anytime.
                        </label>
                      </div>

                      <button disabled={isSubscribing} onClick={submitForm} type="submit" className={`w-full h-11 rounded-full bg-[#6E66E1] text-white text-sm font-bold font-['Figtree'] hover:bg-[#5c4fd6] transition-all duration-300 ease-in-out inline-flex items-center justify-center group ${isSubscribing?'cursor-not-allowed':'cursor-pointer'}`}>
                        Subscribe <svg className="w-3 h-3 ml-1 text-white transform transition-all duration-300 ease-in-out group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth="0.5" viewBox="0 0 12 12">
                        <path d="M0.322291 10.3705L9.4982 1.19455L1.63314 1.19455L1.56572 0.138381H11.3034V9.87608L10.2473 9.80867L10.2473 1.9436L1.07134 11.1195L0.322291 10.3705Z" fill="white"/>
                      </svg>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </motion.section>

          {/* 投资行动号召 */}
          <motion.section
            ref={ref10} initial={startStyle} animate={isRef10InView ? endStyle : {}} transition={animationTransition}
            className="py-24 text-center rounded-t-xl"
            style={{
              background: 'linear-gradient(180deg, #6E66E1 0%, rgba(139, 124, 244, 0.8) 52.39%, rgba(165, 180, 238, 0.347222) 83.65%, rgba(178, 210, 234, 0) 100%)',
            }}
          >
            <div className="max-w-5xl mx-auto">
              <h2 className="text-4xl font-normal font-[‘Figtree’] text-white mb-[30px] leading-none -tracking-wider">
                Ready to Invest in
                <br className="block" />
                Private Technology
                <br className="block" />
                Leaders?
              </h2>
              <p className="text-white text-base font-normal font-['Figtree'] leading-tight -tracking-wide mb-[30px]">Explore how Polaris can<br />enhance your portfolio today.</p>
              <Link to={`/contact-us`} className="inline-flex items-center justify-center h-11 px-8 rounded-full bg-white text-[#6B5AE6] text-sm font-['Figtree'] border border-white/60 font-medium shadow-sm hover:bg-white/95 transition-all duration-300 ease-in-out active:scale-95 group -tracking-wide">
                Contact Us <svg className="w-3 h-3 ml-1 text-[#6E66E1] transform transition-all duration-300 ease-in-out group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth="0" viewBox="0 0 12 12">
                <path d="M0.822291 10.4291L9.9982 1.25314L2.13314 1.25314L2.06572 0.196975L11.8034 0.196975L11.8034 9.93468L10.7473 9.86726L10.7473 2.00219L1.57134 11.1781L0.822291 10.4291Z" fill="#6E66E1"/>
              </svg>
              </Link>
            </div>
          </motion.section>

          {/* 新闻与洞察 */}
          {/* 新闻与洞察 - 暂时隐藏 */}
          <motion.section ref={ref11} initial={startStyle} animate={isRef11InView?endStyle:{}} transition={animationTransition} className="py-20 bg-white px-6 display-none">
            <div className="mx-auto">
              <div className="flex justify-between items-center mb-10">
                <h2 className="text-4xl font-semibold font-['Figtree'] text-[#121212CC] mb-0 leading-9 -tracking-wide">News & Insights</h2>
                <div className="bg-gray-100 flex item-center rounded-full text-gray-700 px-2 py-2 font-medium hover:bg-[#6E66E1] hover:text-white transition-all duration-300 ease-in-out group">
                  <a className="text-[#12121280] text-xs font-medium inline-flex items-center group-hover:text-white transition-colors duration-300 cursor-pointer">
                    View All <svg className="w-4 h-4 ml-2 text-[#12121280] transform transition-all duration-300 ease-in-out group-hover:text-white group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17l9.2-9.2M17 17V7H7" />
                  </svg>
                  </a>
                </div>
              </div>
              {/* inline-flex */}
              <div className="w-[1260px] display-none justify-start items-center gap-14">
                <div className="flex justify-start items-center gap-5">
                  <div className="h-9 px-5 bg-indigo-500 rounded-[100px] outline outline-1 outline-indigo-500 backdrop-blur-[10px] inline-flex flex-col justify-center items-center gap-2.5">
                    <div className="justify-start text-white text-base font-bold font-['Figtree']">All</div>
                  </div>
                  <div className="h-9 px-5 rounded-[100px] outline outline-1 outline-indigo-500 backdrop-blur-[10px] inline-flex flex-col justify-center items-center gap-2.5">
                    <div className="justify-start text-indigo-500 text-base font-medium font-['Figtree']">Polaris Trends</div>
                  </div>
                  <div className="h-9 px-5 rounded-[100px] outline outline-1 outline-indigo-500 backdrop-blur-[10px] inline-flex flex-col justify-center items-center gap-2.5">
                    <div className="justify-start text-indigo-500 text-base font-medium font-['Figtree']">Insights</div>
                  </div>
                  <div className="h-9 px-5 rounded-[100px] outline outline-1 outline-indigo-500 backdrop-blur-[10px] inline-flex flex-col justify-center items-center gap-2.5">
                    <div className="justify-start text-indigo-500 text-base font-medium font-['Figtree']">Events</div>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-10">
                <div className="w-full bg-white overflow-hidden flex flex-col">
                  <div className="relative">
                    <img
                      src={newsBgPic}
                      alt=""
                      className="rounded-xl"
                      style={{position:"absolute", top: 0, left: 0, minWidth: '100%', minHeight: '100%', objectFit: 'cover', objectPosition: 'center'}}
                    />
                    <div className="w-full h-full p-2.5 relative rounded-xl inline-flex justify-start items-start gap-2.5">
                      <div className="left-[12px] top-[126px] absolute inline-flex flex-col justify-start items-start gap-[5px]">
                        <div className="flex flex-col justify-start items-start gap-[0px]">
                          <div className="w-32 justify-start text-white text-2xl font-normal font-['Figtree'] italic capitalize leading-normal">HaoJun Jia</div>
                          <div className="justify-start text-white text-xs font-normal font-['Figtree']">Founder, Deep Principle</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="py-6 text-left flex flex-col flex-1">
                    <h3 className="self-stretch justify-start text-xl font-semibold text-[#414141] mb-10" style={{
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}>
                      AI Investment Paradigm: What Are the Traits of the Next Generation of Great AI Companies?
                    </h3>
                    <div className="flex item-center font-medium mt-auto">
                      <a className="text-[#6E66E1] text-sm font-bold inline-flex items-center group hover:text-[#8586FF] transition-all duration-300 cursor-pointer">
                        Read More <svg className="w-3 h-3 ml-2 text-[#6E66E1] transform transition-all duration-300 ease-in-out group-hover:text-[#8586FF] group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth="0" viewBox="0 0 12 12">
                        <path d="M0.494166 10.7572L9.67008 1.58127L1.80501 1.58127L1.73759 0.5251L11.4753 0.5251L11.4753 10.2628L10.4191 10.1954L10.4191 2.33032L1.24322 11.5062L0.494166 10.7572Z" fill="#6E66E1"/>
                      </svg>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="w-full bg-white overflow-hidden flex flex-col">
                  <div className="relative">
                    <img
                      src={newsBgPic}
                      alt=""
                      className="rounded-xl"
                      style={{position:"absolute", top: 0, left: 0, minWidth: '100%', minHeight: '100%', objectFit: 'cover', objectPosition: 'center'}}
                    />
                    <div className="w-full h-full p-2.5 relative rounded-xl inline-flex justify-start items-start gap-2.5">
                      <div className="left-[12px] top-[126px] absolute inline-flex flex-col justify-start items-start gap-[5px]">
                        <div className="flex flex-col justify-start items-start gap-[0px]">
                          <div className="w-32 justify-start text-white text-2xl font-normal font-['Figtree'] italic capitalize leading-normal">Zhijin Xia</div>
                          <div className="justify-start text-white text-xs font-normal font-['Figtree']">Managing Partner, Vertex Ventures</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="py-6 text-left flex flex-col flex-1">
                    <h3 className="self-stretch justify-start text-xl font-semibold text-[#414141] mb-10" style={{
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}>
                      China’s Opportunity in AI for Science
                    </h3>
                    <div className="flex item-center font-medium mt-auto">
                      <a className="text-[#6E66E1] text-sm font-bold inline-flex items-center group hover:text-[#8586FF] transition-all duration-300 ease-in-out cursor-pointer">
                        Read More <svg className="w-3 h-3 ml-2 text-[#6E66E1] transform transition-all duration-300 ease-in-out group-hover:text-[#8586FF] group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth="0" viewBox="0 0 12 12">
                        <path d="M0.494166 10.7572L9.67008 1.58127L1.80501 1.58127L1.73759 0.5251L11.4753 0.5251L11.4753 10.2628L10.4191 10.1954L10.4191 2.33032L1.24322 11.5062L0.494166 10.7572Z" fill="#6E66E1"/>
                      </svg>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="w-full bg-white overflow-hidden flex flex-col">
                  <div className="relative">
                    <img
                      src={newsBgPic}
                      alt=""
                      className="rounded-xl"
                      style={{position:"absolute", top: 0, left: 0, minWidth: '100%', minHeight: '100%', objectFit: 'cover', objectPosition: 'center'}}
                    />
                    <div className="w-full h-full p-2.5 relative rounded-xl inline-flex justify-start items-start gap-2.5">
                      <div className="left-[12px] top-[126px] absolute inline-flex flex-col justify-start items-start gap-[5px]">
                        <div className="flex flex-col justify-start items-start gap-[0px]">
                          <div className="w-52 justify-start text-white text-2xl font-normal font-['Figtree'] italic capitalize leading-normal">Grant Hosking</div>
                          <div className="justify-start text-white text-xs font-normal font-['Figtree']">Managing Partner, Align Ventures; Figure AI Board Member</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="py-6 text-left flex flex-col flex-1">
                    <h3 className="self-stretch justify-start text-xl font-semibold text-[#414141] mb-10" style={{
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}>
                      Humanoid Robots Will Ultimately Become a Trillion-Dollar Industry; Brett May Become the Next Musk
                    </h3>
                    <div className="flex item-center font-medium mt-auto">
                      <a className="text-[#6E66E1] text-sm font-bold inline-flex items-center group hover:text-[#8586FF] transition-all duration-300 ease-in-out cursor-pointer">
                        Read More <svg className="w-3 h-3 ml-2 text-[#6E66E1] transform transition-all duration-300 ease-in-out group-hover:text-[#8586FF] group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth="0" viewBox="0 0 12 12">
                        <path d="M0.494166 10.7572L9.67008 1.58127L1.80501 1.58127L1.73759 0.5251L11.4753 0.5251L11.4753 10.2628L10.4191 10.1954L10.4191 2.33032L1.24322 11.5062L0.494166 10.7572Z" fill="#6E66E1"/>
                      </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.section>
        </section>
      </div>
  );
}
